// Frontend mirror of backend/services/wipOrderLogic.js — stitch classification,
// ideal date computation and stage aging. Keep in sync with the backend copy.

export const DEFAULT_TIMELINES = {
  unstitched: { issuance: 1, receiving: 2, dispatch: 3, delivery: 6 },
  stitched:   { issuance: 3, receiving: 7, dispatch: 10, delivery: 20 },
};
export const STITCH_RULES = DEFAULT_TIMELINES;

// Stage → { ideal key, actual key }. Dispatch/delivery keep their historical keys.
export const STAGE_KEYS = {
  issuance:  { ideal: 'issuanceIdeal',     actual: 'issuanceActual',  label: 'Issuance' },
  receiving: { ideal: 'receivingIdeal',    actual: 'receivingActual', label: 'Receiving' },
  dispatch:  { ideal: 'idealIssuanceDate', actual: 'issuanceDate',    label: 'Dispatch' },
  delivery:  { ideal: 'idealDeliveryDate', actual: 'actualDeliveryDate', label: 'Delivery' },
};

export function normalizeStitch(text) {
  const t = String(text || '').toLowerCase();
  if (!t.trim()) return '';
  if (/\bun[\s-]?stitch/.test(t) || /\bunstitched\b/.test(t)) return 'unstitched';
  if (/stitch/.test(t) || /\bpret\b/.test(t) || /ready[\s-]?to[\s-]?wear/.test(t)) return 'stitched';
  return '';
}

export const addDays = (dateStr, days) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export function idealDates(orderDate, stitchCategory, timelines) {
  const t = (timelines && timelines[stitchCategory]) || DEFAULT_TIMELINES[stitchCategory];
  if (!orderDate || !t) return {};
  const num = (v, d) => (v === 0 || Number.isFinite(Number(v))) ? Number(v) : d;
  const dflt = DEFAULT_TIMELINES[stitchCategory] || {};
  return {
    issuanceIdeal:     addDays(orderDate, num(t.issuance, dflt.issuance)),
    receivingIdeal:    addDays(orderDate, num(t.receiving, dflt.receiving)),
    idealIssuanceDate: addDays(orderDate, num(t.dispatch, dflt.dispatch)),
    idealDeliveryDate: addDays(orderDate, num(t.delivery, dflt.delivery)),
  };
}

const toTime = (s) => { const d = new Date(s); return isNaN(d.getTime()) ? null : d.getTime(); };
const DAY = 86400000;

// Aging for one stage from its ideal/actual date pair.
export function stageAging(fields, idealKey, actualKey) {
  const f = fields || {};
  const ideal = toTime(f[idealKey]);
  if (ideal == null) return { done: toTime(f[actualKey]) != null, delayed: false, days: null };
  const actual = toTime(f[actualKey]);
  const todayT = toTime(new Date().toISOString().slice(0, 10));
  if (actual != null) { const days = Math.round((actual - ideal) / DAY); return { done: true, delayed: days > 0, days }; }
  const overdue = Math.round((todayT - ideal) / DAY);
  return { done: false, delayed: todayT > ideal, days: overdue > 0 ? overdue : 0 };
}

export function deriveOrderFlags(fields = {}) {
  const f = fields || {};
  const ff = String(f.fulfillmentStatus || '');
  return {
    delayedIssuanceStage: stageAging(f, STAGE_KEYS.issuance.ideal, STAGE_KEYS.issuance.actual).delayed,
    delayedReceiving:     stageAging(f, STAGE_KEYS.receiving.ideal, STAGE_KEYS.receiving.actual).delayed,
    delayedIssuance:      stageAging(f, STAGE_KEYS.dispatch.ideal, STAGE_KEYS.dispatch.actual).delayed,
    delayedDelivery:      stageAging(f, STAGE_KEYS.delivery.ideal, STAGE_KEYS.delivery.actual).delayed,
    fulfilled: /fulfilled/i.test(ff) && !/^un/i.test(ff),
    delivered: /delivered/i.test(String(f.deliveryStatus || '')),
  };
}
